export default "__VITE_ASSET__at$O1QOh__"